import {
  Collection,
  Publication,
  TechDomainDisplayNames,
} from '@amzn/awscat-pattern-library-service-model';

import {
  awsServiceReadonlyDisplayNames,
  environmentDisplayNames,
  rTypeDisplayNames,
  workloadDisplayNames,
} from '../../utils/DisplayNames';
import { Filters, FilterCategory, FilterOption } from '../../content/ContentFilters';
import { createPublicationFilterOption, FilterOptionToApply } from '../../utils/ContentFilterUtils';
import { CollectionWithTemplateMetaData } from './CommunityCollection';

export const getCollecitonsInitialFilterOptions = (hideFilterCategory: FilterCategory[] = []) => {
  const initialFilterOptions: Filters = {
    // @ts-expect-error TS2322 - strict migration
    techDomains: createPublicationFilterOption(
      FilterCategory.TechDomains,
      TechDomainDisplayNames,
      [],
    ),
    // @ts-expect-error TS2322 - strict migration
    rType: createPublicationFilterOption(FilterCategory.RType, rTypeDisplayNames, []),
    // @ts-expect-error TS2322 - strict migration
    awsServices: createPublicationFilterOption(
      FilterCategory.AwsServices,
      awsServiceReadonlyDisplayNames,
      [],
    ),
    // @ts-expect-error TS2322 - strict migration
    environment: createPublicationFilterOption(
      FilterCategory.Environment,
      environmentDisplayNames,
      [],
    ),
    // @ts-expect-error TS2322 - strict migration
    workload: createPublicationFilterOption(FilterCategory.Workload, workloadDisplayNames, []),
    // @ts-expect-error TS2322 - strict migration
    isFavoriteCollection: createPublicationFilterOption(
      FilterCategory.IsFavoriteCollection,
      // @ts-expect-error TS2345 - strict migration
      null,
      hideFilterCategory,
    ),
  };
  return initialFilterOptions;
};

export const applyFilterToCollection = (
  collection: CollectionWithTemplateMetaData,
  filtersToApply: FilterOptionToApply[],
) => {
  return filtersToApply.every((filter) => {
    return filter.values.some((value) => {
      const filterValue =
        filter.metadata !== ''
          ? // @ts-expect-error TS7053 - strict migration
            collection[filter.metadata][value]
          : filter.mappedValues
            ? // @ts-expect-error TS7053 - strict migration
              filter.mappedValues.get(collection[value])
            : // @ts-expect-error TS7053 - strict migration
              collection[value];
      if (typeof filterValue === 'boolean') {
        return filterValue;
      } else if (typeof filterValue === 'string') {
        return (
          filterValue &&
          filter.options.some((option: FilterOption) => {
            return option.value === filterValue;
          })
        );
      } else {
        return (
          filterValue &&
          filter.options.some((option: FilterOption) => filterValue.includes(option.value))
        );
      }
    });
  });
};

export const mergeCollectionsWithMetadata = (
  collections: Collection[],
  publications: Publication[],
) => {
  const publicationIdMap = new Map<string, Publication>();
  publications.forEach((publication) => publicationIdMap.set(publication.contentId, publication));
  const collecitonsWithMetadata = collections.map((collection) => {
    // @ts-expect-error TS7034 - strict migration
    const publicationIds = [];
    const { epics } = collection;
    epics?.forEach((epic) => {
      const { stories } = epic;
      stories.forEach((story) => {
        publicationIds.push(story?.publicationId);
      });
    });
    const environmentsSet = new Set();
    const mainTechDomainsSet = new Set();
    const awsServicesSet = new Set();
    const techDomainsSet = new Set();
    const workloadSet = new Set();
    // @ts-expect-error TS7005 - strict migration
    publicationIds.forEach((publicationId) => {
      const publication = publicationIdMap.get(publicationId);
      if (publication && publication?.templateMetadata) {
        const { templateMetadata } = publication;
        const { environment, mainTechDomain, awsServices, techDomains, workload } =
          templateMetadata;
        if (environment) {
          environmentsSet.add(environment);
        }
        if (mainTechDomain) {
          mainTechDomainsSet.add(mainTechDomain);
        }
        if (awsServices?.length) {
          // @ts-expect-error TS7006 - strict migration
          awsServices.forEach((awsService) => awsServicesSet.add(awsService));
        }
        if (techDomains?.length) {
          // @ts-expect-error TS7006 - strict migration
          techDomains.forEach((techDomain) => techDomainsSet.add(techDomain));
        }
        if (workload?.length) {
          // @ts-expect-error TS7006 - strict migration
          workload.forEach((workloadItem) => workloadSet.add(workloadItem));
        }
      }
    });
    return {
      ...collection,
      templateMetadata: {
        environment: Array.from(environmentsSet),
        mainTechDomain: Array.from(mainTechDomainsSet),
        techDomains: Array.from(techDomainsSet),
        awsServices: Array.from(awsServicesSet),
        workload: Array.from(workloadSet),
      },
    };
  });
  return collecitonsWithMetadata;
};
